var _a, _b;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { AiTaggingRepository } from '../repositories/ai-tagging-repository.interface';
import { DetailService } from '@/services/DetailService';
let FieldsServiceImpl = class FieldsServiceImpl {
    constructor(_aiTaggingRepository, _detailService) {
        this._aiTaggingRepository = _aiTaggingRepository;
        this._detailService = _detailService;
    }
    getFields(params) {
        return this._aiTaggingRepository.getFields(params);
    }
    showField(currentField) {
        const to_index = this._detailService.patentVisibleFields.length;
        return this._aiTaggingRepository.showField({
            space_id: this._detailService.spaceId,
            folder_id: this._detailService.folderId,
            action: 'SHOW',
            data: {
                fields: [currentField.field_id],
                to_index,
            },
            data_type: 'PATENT',
            view_type: this._detailService.viewMode2,
        });
    }
};
FieldsServiceImpl = __decorate([
    injectable(),
    __param(0, inject(AiTaggingRepository)),
    __param(1, inject(DetailService)),
    __metadata("design:paramtypes", [typeof (_a = typeof AiTaggingRepository !== "undefined" && AiTaggingRepository) === "function" ? _a : Object, typeof (_b = typeof DetailService !== "undefined" && DetailService) === "function" ? _b : Object])
], FieldsServiceImpl);
export { FieldsServiceImpl };
